import { StateInterface } from "./state";
import { ManualModel } from "../models";

export default {
  allManuals(state: StateInterface): ManualModel[] {
    return state.manuals;
  },
  allTags(state: StateInterface): string[] {
    const hash: { [key: string]: boolean } = {};
    const allTags: string[] = [];
    for (const manual of state.manuals) {
      if (manual.tags === null) continue;
      for (const tag of manual.tags) {
        if (hash[tag] === true) continue;
        allTags.push(tag);
        hash[tag] = true;
      }
    }
    return allTags.sort();
  },
};
